export class Hospital {
    id: number
    nome: string
    cnes: string
    telefone: string
}